module.exports = __webpack_public_path__ + "static/media/current-plan.de0eb7e2.svg";